import React from 'react'
import "./TermsConditions.css"
import { InnerPageHeader } from '../../components'
import { Container } from "react-bootstrap"
import { useTranslation } from '../../contexts/TranslationContext';

const TermsConditions = ({ pageData }) => {

    console.log("pageData:", pageData)
    const templates = pageData?.content?.templates[0] || [];
  const { t } = useTranslation();

    return (
        <div>
             <InnerPageHeader
                title= {t("Terms")}
            />
            <Container>

            <div className='inner-pages-para'>
                {templates.data?.terms_conditions && (
                    <div
                    className="prose"
                    dangerouslySetInnerHTML={{
                        __html: templates.data.terms_conditions,
                    }}
                    />
                )}
            </div>
        
            </Container>
        </div>
    )
}

export default TermsConditions
